export default __webpack_public_path__ + "static/media/cambiaree.0a64b950.jpg";